<template>
  <div id="lead-event-history">
    <div class="ld-unit-details">
      <div class="ld-row-container">
        <div class="ld-header">
          Event History
        </div>
      </div>
      <div
        v-if="alert.drainPan"
        class="margin-top-4"
      >
        <div class="ld-row-container-2">
          <div class="ld-sub">
            <div class="ld-label">
              MFR.
            </div>
            <div class="ld-text">
              {{ hvac.manufacturer || '--' }}
            </div>
          </div>
          <div class="ld-sub">
            <div class="ld-label">
              Speed
            </div>
            <div class="ld-text">
              {{ hvac.speed || '--' }}
            </div>
          </div>
          <div class="ld-sub">
            <div class="ld-label">
              Refrigerant
            </div>
            <div class="ld-text">
              {{ hvac.refrigerant || '--' }}
            </div>
          </div>
          <div class="ld-sub">
            <div class="ld-label">
              Model
            </div>
            <div class="ld-text">
              {{ hvac.model || '--' }}
            </div>
          </div>
        </div>
        <div class="ld-row-container-2">
          <div class="ld-sub">
            <div class="ld-label">
              MFR. Date
            </div>
            <div class="ld-text">
              {{ hvac.mfgDate || '--' }}
            </div>
          </div>
          <div class="ld-sub">
            <div class="ld-label">
              Type
            </div>
            <div class="ld-text">
              {{ hvac.type || '--' }}
            </div>
          </div>
          <div class="ld-sub">
            <div class="ld-label">
              Unit Age
            </div>
            <div class="ld-text">
              {{ hvac.age || '--' }}
            </div>
          </div>
          <div class="ld-sub">
            <div class="ld-label">
              Serial
            </div>
            <div class="ld-text">
              {{ hvac.serialNumber || '--' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <LeakLineHistoryGraph />
    <ThirtyDaysLeakHistory />
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';
import LeakLineHistoryGraph from './LeakLineHistoryGraph.vue';
import ThirtyDaysLeakHistory from './ThirtyDaysLeakHistory.vue';

export default {
  name: 'LeakEventHistory',
  components: {
    ThirtyDaysLeakHistory,
    LeakLineHistoryGraph,
  },
  mixins: [leadDetailMixin],
};
</script>

<style lang="scss">

#lead-event-history {
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(243,244,246,1) 30%);
  display: grid;
  align-content: space-between;
  padding: 1rem 2rem;
  width: 100%;
  .ld-unit-details {
    .ld-row-container {
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      .ld-header {
        font-weight: 700;
        color: $N100;
        font-size: 12pt;
      }
      .ld-mini-header {
        font-weight: 700;
        color: $N100;
        font-size: 8pt;
      }
      .ld-label {
        font-weight: 500;
        font-size: 8pt;
      }
      .ld-text {
        font-size: 8pt;
      }
    }
    .ld-row-container-2 {
      display: grid;
      grid-template-columns: 24% 24% 24% 20%;
      gap: 1rem;
      grid-auto-flow: column;
      justify-content: space-between;
      .ld-sub {
        display: grid;
        grid-auto-flow: column;
        justify-content: space-between;
        font-size: 0.75rem;
        width: 100%;
        &:not(:nth-child(4)):not(:nth-child(8)) {
          border-right: 1px solid $N40;
          padding-right: 22px;
        }
      }
    }
  }
}

</style>
